<template>

  <v-container fluid class="main-navigation-receiver">

    <!-- Home page -->
    <router-link :to="{ name: 'home' }">
      <v-btn plain class="primary-nav-element" @click="emitClickEvent">
        <v-icon small class="mr-2">mdi-home</v-icon> Home
      </v-btn>
    </router-link>

    <!-- Track Order -->
    <router-link :to="{ name: 'track-order' }">
      <v-btn plain class="primary-nav-element mt-5" @click="emitClickEvent">
        <v-icon small class="mr-2">mdi-target</v-icon> Track Order
      </v-btn>
    </router-link>

    <!-- Orders -->
    <router-link :to="{ name: 'receiver-order-list' }">
      <v-btn plain class="primary-nav-element mt-5" @click="emitClickEvent">
        <v-icon small class="mr-2">mdi-package-variant-closed</v-icon> Orders
      </v-btn>
    </router-link>

    <!-- Credits -->
    <router-link :to="{ name: 'receiver-credit-list' }">
      <v-btn plain class="primary-nav-element mt-5" @click="emitClickEvent">
        <v-icon small class="mr-2">mdi-credit-card</v-icon> Credits
      </v-btn>
    </router-link>

    <!-- Receiver Locations -->
    <router-link :to="{ name: 'receiver-ui-receiver-location-list' }">
      <v-btn plain class="primary-nav-element mt-5" @click="emitClickEvent">
        <v-icon small class="mr-2">mdi-store</v-icon> Receiver Locations
      </v-btn>
    </router-link>

    <!-- Org profile -->
    <router-link :to="{ name: 'org-profile' }">
      <v-btn plain class="primary-nav-element mt-5" @click="emitClickEvent">
        <v-icon small class="mr-2">mdi-account-circle-outline</v-icon> Org Profile
      </v-btn>
    </router-link>

    <!-- Org members -->
    <router-link :to="{ name: 'user-list' }">
      <v-btn plain class="primary-nav-element mt-5" @click="emitClickEvent">
        <v-icon small class="mr-2">mdi-account-multiple</v-icon> Org Members
      </v-btn>
    </router-link>

    <!-- User settings -->
    <router-link :to="{ name: 'user-settings-profile' }">
      <v-btn plain class="primary-nav-element mt-5" @click="emitClickEvent">
        <v-icon small class="mr-2">mdi-cog</v-icon> User Settings
      </v-btn>
    </router-link>

    <!-- Logout -->
    <div>
      <v-btn plain class="primary-nav-element mt-5" @click="$root.logout">
        <v-icon small class="mr-2">mdi-logout</v-icon> Logout
      </v-btn>
    </div>

    <div class="spacer" />

    <!-- Terms of Use -->
    <v-row align="end">
      <v-col align="center">
        <router-link :to="{ name: 'terms-of-use' }">
          <v-btn color="primary" plain class="primary-nav-element" @click="emitClickEvent">
            Terms of Use
          </v-btn>
        </router-link>
      </v-col>
    </v-row>

  </v-container>

</template>

<script>
export default {
  name: 'MainNavigationReceiverUi',

  data () {
    return {
      manageOrgNavSetting: 0
    }
  },

  computed: {
  },

  methods: {
    emitClickEvent () {
      this.$emit('navClicked')
    }
  }
}
</script>

<style>
  .main-navigation-receiver {
    display: flex;
    flex-direction: column;
    height: 100vh;
  }

  .main-navigation-receiver .primary-nav-element {
    padding-left: 8px !important;
  }

  .spacer {
    flex-grow: 1;
  }
</style>
